document.addEventListener("DOMContentLoaded", () => {
    const maxWait = 5000;
    const interval = 50;
    const waitForLookfyGallery = (cb, start = Date.now()) => {
        const el = document.querySelector(".lookfy-gallery");
        if (el && el.children.length > 0) return cb();
        if (Date.now() - start < maxWait) setTimeout(() => waitForLookfyGallery(cb, start), interval);
    };

    waitForLookfyGallery(() => {
        const marketUri = Shopify.routes.root.slice(0, -1);
        document.querySelectorAll(".lookfy-gallery a[href]").forEach((a) => {
            const url = new URL(a.href, window.location.origin);
            if (url.hostname.includes("elora.com") && !a.href.includes(marketUri)) {
                a.href = `${url.origin}${marketUri}${url.pathname}${url.search}${url.hash}`;
            }
        });
    });
});
